import {Collection} from "vue-mc"
import jobActivityReportModel from "@/models/jobActivityReportModel"

import Vue from "vue";

export default class jobActivityReportCollection extends Collection {

    model() {
        return jobActivityReportModel;
    }

    defaults() {
        return {
            inBuiltApi: Vue.prototype.$interpretersApiUrl,
            methodTypes: 'list',
            data: {
                jobID: localStorage.getItem('jwt')
            },
            dbData: {}
        }
    }

    options() {
        return {
            methods: {
                list: 'GET',
                unreadPaymentCount: 'GET'
            }
        }
    }

    routes() {
        return {
            list: 'interpreter/payments',
            unreadPaymentCount: 'interpreter/payments/unread/count'
        }
    }

    requestRoute() {

        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.' + this.getAttributes().methodTypes);
        let route = this.getAttributes().inBuiltApi + this.getRoute(this.getAttributes().methodTypes);
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        let data = this.getAttributes().data;

        // console.log(headers, method, url, data);

        return this.getRequest({headers, method, url, data}).send();
    }

    getList() {
        return this.requestRoute();
    }

    getUnreadPaymentsCount() {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.unreadPaymentCount');
        let route = Vue.prototype.$apiAllGraduatesUrl + this.getRoute('unreadPaymentCount');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url}).send();
    }
}
